import React, { useEffect, useRef, useState } from "react";
import { Table, Button, Form } from "react-bootstrap";
import Layout from "../../components/Layout";
import { useNavigate } from "react-router-dom";
import ToastFile from "../../utils/ToastFile";
import { getAllTaskLogbyContractor, getAllTaskLogbyTenant } from "../../api/TaskApi";
import moment from "moment";
import Select from "react-select";
import { getAllEmployeebyContractor } from "../../api/EmployeeApi";
import { getAllRoutebyContractor } from "../../api/RouteApi";
import Loader from "../../components/Loader";

const Reports = () => {
  const [taskLogs, setTaskLogs] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [routeOptions, setRouteOptions] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });
  const fetched = useRef(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const [isLoading, setIsloading] = useState(false);

  useEffect(() => {
    if (fetched.current) return;
    fetched.current = true;
    //getTaskLog();
    getEmployee();
    getRoute();
  }, []);

  const getEmployee = () => {
    getAllEmployeebyContractor(user.tenant_id)
      .then((res) => {
        setEmployees(res?.data?.data?.employees);
        const options = res?.data?.data?.employees.map((emp) => ({
          value: emp._id,
          label: emp.name,
        }));
        setEmployeeOptions([{ value: null, label: "All Employees" },...options]);
      })
      .catch((err) => {
        console.error("Error fetching employees:", err);
      });
  };

  const getTaskLog = () => {
    setIsloading(true)
    let employee = selectedEmployee || null;
    let startDate = date?.startDate
      ? moment(new Date(date.startDate)).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD");
    let endDate = date?.endDate
      ? moment(new Date(date.endDate)).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD");

    getAllTaskLogbyTenant(user.tenant_id, employee, startDate, endDate)
      .then((res) => {
        if (res.status === 200) {
          const filteredLogs = res.data.data.taskLogs.filter(
            (el) => el.isApproved === "Yes"
          );
          if (filteredLogs.length === 0) {
            ToastFile(
              "No record found for this employee in selected period",
              "error"
            );
            setTaskLogs(null);
            return;
          }
          setTaskLogs(filteredLogs);
        } else {
          ToastFile("Failed to fetch tasks", "error");
        }
      })
      .catch((err) => {
        console.error("Error fetching tasks:", err);
        ToastFile("Error fetching tasks", "error");
      })
      .finally(()=>{
        setIsloading(false)
      })
  };

  const onSelect = (employee_id) => {
    setSelectedEmployee(employee_id);
  };

  const getRoute = () => {
    getAllRoutebyContractor(user.tenant_id)
      .then((res) => {
        if (res.status === 200) {
          setRouteOptions(res?.data?.data?.routes);
        } else {
          ToastFile("Failed to fetch routes", "error");
        }
      })
      .catch((err) => {
        console.error("Error fetching routes:", err);
        ToastFile("Error fetching routes", "error");
      });
  };

  //calculate total amount
  const totalClaimHours = taskLogs?.reduce(
    (sum, log) => sum + (parseFloat(log.claimHours) || 0),
    0
  );

  const totalFuelCost = taskLogs?.reduce(
    (sum, log) => sum + (parseFloat(log.fuelCost) || 0),
    0
  );

  const totalAmount = taskLogs?.reduce(
    (sum, log) => sum + parseFloat(log.claimHours * (log.payrate || 0)),
    0
  );

  const Total = totalAmount + totalFuelCost;

  const decimalNumber = (num) => {
    return isNaN(num) ? 0 : Number(num).toFixed(2); 
  }

  return (
    <Layout>
      <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
        <h3 className="mb-0">Reports</h3>
      </div>
      <div className="card mb-4">
        <div className="card-body">
          <Form>
            <div className="row g-3">
              <div className="col-12 col-md-6 col-lg-3">
                <Form.Group>
                  <Form.Label className="fw-bold">Employee</Form.Label>
                  <Select
                    options={employeeOptions}
                    placeholder="Search employee"
                    onChange={(selected) => onSelect(selected?.value)}
                    isClearable
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </Form.Group>
              </div>
              <div className="col-12 col-md-6 col-lg-3">
                <Form.Group>
                  <Form.Label className="fw-bold">Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="startDate"
                    defaultValue={new Date().toISOString().split("T")[0]}
                    onChange={(e) =>
                      setDate((prev) => ({
                        ...prev,
                        startDate: e.target.value,
                      }))
                    }
                  />
                </Form.Group>
              </div>

              <div className="col-12 col-md-6 col-lg-3">
                <Form.Group>
                  <Form.Label className="fw-bold">End Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="endDate"
                    defaultValue={new Date().toISOString().split("T")[0]}
                    onChange={(e) =>
                      setDate((prev) => ({ ...prev, endDate: e.target.value }))
                    }
                  />
                </Form.Group>
              </div>
              <div className="col-12 col-md-6 col-lg-3 d-flex align-items-end">
                <Button
                  variant="success"
                  onClick={getTaskLog}
                  className="w-100 d-flex align-items-center justify-content-center gap-2"
                >
                  Generate Report
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </div>

      <Table striped bordered hover responsive>
        <thead className="table-dark">
          <tr style={{ textAlign:'center' }}>
            <th>Employee</th>
            <th>Category</th>
            <th>Route</th>
            <th>Date</th>
            <th>Start Time</th>
            <th>End Time</th>
            <th>Claim Hours / No of Parcels</th>
            <th>Pay Rate / Per Parcel Cost ($)</th>
            <th>Pay ($)</th>
            <th>Fuel Cost ($)</th>
            <th>Total Pay ($)</th>
            {/* <th>Status</th> */}
          </tr>
        </thead>
        {isLoading ? <tbody>
              <tr>
                <td colSpan="12">
                  <Loader/>
                </td>
              </tr>
            </tbody>
            :
        <tbody>
          {taskLogs?.length === 0 ? (
            <tr>
              <td colSpan="12" className="text-center">
                No task found
              </td>
            </tr>
          ) : (
            taskLogs?.map((c, idx) => {
              return(
              <tr key={idx}>
                <td>{employees?.find((el) => el._id === c.employee)?.name}</td>
                <td>{c.category}</td>
                <td>
                  {c.routeInfo.map((item, index) => {
                    const matched = routeOptions.find((el) => el._id === item);
                    return (
                      <span key={index}>
                        {matched?.routeName}
                        {index < c.routeInfo.length - 1 ? ", " : ""}
                      </span>
                    );
                  })}
                </td>
                <td style={{ textAlign:'center' }}>{moment(c.date).format("DD-MM-YYYY")}</td>
                <td style={{ textAlign:'center' }}>{moment(c.startTime).format("hh:mm A")}</td>
                <td style={{ textAlign:'center' }}>{c.endTime ? moment(c.endTime).format("hh:mm A") : ""}</td>
                <td style={{ textAlign:'end' }}>{c.claimHours}</td>
                <td style={{ textAlign:'end' }}>
                  {c.payrate}
                </td>
                <td style={{ textAlign:'end' }}>
                  {decimalNumber(Number(c.payrate) * Number(c.claimHours))}
                </td>
                <td style={{ textAlign:'end' }}>{c.fuelCost}</td>
                <td style={{ textAlign:'end' }}>
                  {decimalNumber(Number(c.payrate) *
                    Number(c.claimHours) +
                    Number(c.fuelCost))}
                </td>
              </tr>
            )})
          )}
          {taskLogs?.length > 0  && (
            <tr>
              <td colSpan="6">
                <b>Total Payable Amount</b>
              </td>
              <td style={{ textAlign:'end' }}>
                <b>{totalClaimHours}</b>
              </td>
              <td>
                {/* <b>{payRate}</b> */}
              </td>
              <td style={{ textAlign:'end' }}>
                <b>{(totalAmount || 0).toFixed(2)}</b>
              </td>
              <td style={{ textAlign:'end' }}>
                <b>{(totalFuelCost || 0).toFixed(2)}</b>
              </td>
              <td style={{ textAlign:'end' }}>
                <b>{(Total || 0).toFixed(2)}</b>
              </td>
            </tr>
          )}
        </tbody>}
      </Table>
    </Layout>
  );
};

export default Reports;
